<div class="audit-height">
    <p-table 
        #dt
        [columns]="this.visibleColumns"
        [value]="$safeNavigationMigration(this.lazyLoadVm?.data)"
        dataKey="id"
        [rowHover]="true"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="this.lts.rowsPerPageOptions"
        [loading]="isLoading"
        [paginator]="true"
        [currentPageReportTemplate]="'Showing {first} to {last} of ' + decimalPipe.transform($safeNavigationMigration(lazyLoadVm?.totalRecords)) + ' entries'"
        [filterDelay]="500"
        [size]="'small'"
        stripedRows 
        selectionMode="single"    
        [globalFilterFields]='this.searchColumns'
        [dt]="tableDts"    
        [rows]="this.lts.pageSize"
        [totalRecords]="$safeNavigationMigration(this.lazyLoadVm?.totalRecords)"
        (onPage)="this.lts.onPageChange($event, this.dataSource, this.lazyTableInput, this.filters)"
        [lazy]="true"
        (onLazyLoad)="loadLazy($event)" 
        [scrollable]="true"
        scrollHeight="flex"
    >

        <ng-template #caption>
            <div class="d-flex">
                <p-multiselect 
                    display="chip" 
                    [options]="this.availableColumns" 
                    [(ngModel)]="this.visibleColumns" 
                    optionLabel="header" 
                    selectedItemsLabel="Show / Hide" 
                    [style]="{ 'min-width': '100px' }" 
                    placeholder="Choose Columns" 
                    (ngModelChange)="
                        this.lts.columnChange(
                            $event
                            , this.availableColumns
                            , this.visibleColumns
                        )
                    "
                />

                <p-button 
                    class="ml-1 border border-secondary rounded"
                    (click)="opp.toggle($event)" 
                    icon="pi pi-filter-fill" 
                    label="Filters" 
                    severity="secondary"
                />
                <p-popover #opp>
                    <div class="d-flex flex-column">
                        <span class="mb-2">
                            <label class='for'>Business Area</label>
                            <p-multiselect 
                                [(ngModel)]="selectedBusinessAreas" 
                                [options]="filterBusinessAreas" 
                                placeholder="Select..." 
                                (onChange)="
                                    stringifyFilters(); 
                                    this.getList();
                                " 
                                optionLabel="text" 
                                optionValue="value"
                                style="min-width: 15.5rem" 
                                [panelStyle]="{ minWidth: '16rem' }"
                            />
                        </span>
                    
                        <span class="mb-2">
                            <label class='for'>Date Changed</label>
                            <p-datepicker 
                                #drp
                                [(ngModel)]="filterDateChanged" 
                                [maxDate]="this.lts.endDate" 
                                [readonlyInput]="true" 
                                [showIcon]="true" 
                                [showOnFocus]="true" 
                                selectionMode="range" 
                                [numberOfMonths]="2" 
                                [showOtherMonths]="true" 
                                [hideOnDateTimeSelect]="false" 
                                inputId="basic" 
                            >
                                <p-footer class="w-100 text-center p-1">
                                    <button 
                                        (click)="
                                            this.filters.dateChanged = this.lts.dateRangeChange($safeNavigationMigration(drp?.value), drp);
                                            this.getList();
                                        " 
                                        class="btn btn-outline-secondary"
                                    >Apply</button>
                                    <button 
                                        (click)="
                                            this.filters.dateChanged = clearDateRange();
                                            this.getList();
                                        " 
                                        class="btn btn-outline-secondary ml-1"
                                    >Clear</button>
                                </p-footer>
                            </p-datepicker>
                            <input 
                                type="hidden" 
                                (focus)="
                                    drp?.overlayVisible 
                                    && drp?.toggle()
                                "
                            />
                        </span>

                        <span class="mb-2">
                            <label class='for'>Changed By</label>
                            <p-select 
                                [(ngModel)]="filters.changedBy" 
                                [options]="filterChangedBy" 
                                placeholder="Select..." 
                                (onChange)="
                                    this.filters.changedBy = $event.value;
                                    this.getList();
                                " 
                                optionLabel="text" 
                                optionValue="value"
                                style="min-width: 15.5rem" 
                                [panelStyle]="{ minWidth: '16rem' }"
                            />
                        </span>

                        <span>
                            <label class='for'>RX Number</label>
                            <input 
                                class='form-control mr-2' 
                                type="text" 
                                [(ngModel)]='filters.rx' 
                                placeholder='Enter an RX Number' 
                                (change)="
                                    this.getList();
                                " 
                            />
                        </span>
                    </div>
                </p-popover>

                @if (hasFilters) {
                    <p-button 
                        class="pl-1"
                        icon="pi pi-filter-slash" 
                        [label]="lts.getActiveFilters(filters, filterMap, initFilters)"
                        severity="success"
                        [outlined]="true" 
                        (click)="clearFilters()" 
                    />
                }
            </div>
        </ng-template>

        <ng-template 
            #header
            let-columns
        >
            <tr>
                @for (col of columns; track col.field; let i = $index) {
                    <th 
                        [pSortableColumn]="col?.canSort ? $safeNavigationMigration(col?.field) : null" 
                        [class]="col?.cellClass"
                    >
                        {{ col?.header }} 
                        @if (col?.canSort) { <p-sortIcon [field]="$safeNavigationMigration(col?.field)" /> }
                    </th>
                }
            </tr>
        </ng-template>

        <ng-template 
            #body 
            let-row
            let-columns="columns"
        >
            <tr>
                @for (col of columns; track col.field; let i = $index) {
                    @if (col?.field == "changedFrom") {
                        <td 
                            [class]="col?.cellClass"
                            [innerHTML]="fhs.sanitizeHTML($safeNavigationMigration(row?.changedFrom))"
                            data-dd-privacy="mask"
                        ></td>
                    } @else if (col?.field == "changedTo") {
                        <td 
                            [class]="col?.cellClass"
                            [innerHTML]="fhs.sanitizeHTML($safeNavigationMigration(row?.changedTo))"
                            data-dd-privacy="mask"
                        ></td>
                    } @else if (col?.field == "recordAffected") {
                        <td 
                            [class]="col?.cellClass"
                            [innerHTML]="fhs.sanitizeHTML($safeNavigationMigration(row?.recordAffected))"
                            data-dd-privacy="mask"
                        ></td>
                    } @else if (col?.field == "field") {
                        <td 
                            [class]="col?.cellClass"
                            [attr.data-dd-privacy]="row?.module == 'Inventory | Rx Fulfillment' ? 'mask' : null"
                            [innerHTML]="fhs.sanitizeHTML($safeNavigationMigration(row?.field))"
                        ></td>
                    } @else {
                        <td [class]="col?.cellClass">
                            @if (col?.field == "dateChanged") { {{ row?.dateChangedFormatted }} }
                            @else if (col?.field == "businessArea") {
                                {{ parseBusinessAreaEnumToDescription($safeNavigationMigration(row?.businessArea)) }}
                            } @else if (col?.field == "module") { {{ row?.module }}
                            } @else if (col?.field == "changedBy") {
                                @if (row?.pfsLink) { <a [href]='$safeNavigationMigration(row?.pfsLink)' target="_blank">{{ row?.changedBy }}</a> } 
                                @else { {{ row?.changedBy }} }                        
                            } @else { {{ row![col?.field] }} }
                        </td>
                    }
                    
                }
            </tr>
        </ng-template>

        <ng-template #emptymessage>
            <tr>
                <td 
                    colspan="999" 
                    class="text-center"
                >No records found.</td>
            </tr>
        </ng-template>
    </p-table>
</div>
